import React from 'react'
import { useTranslation } from 'react-i18next'
import { Whisper, Tooltip } from 'rsuite'

import ProductIntendedMaterials from './../product/intended-materials'


const ProductsListSingleItem = ({ product, purposes, intendedMaterials, onClick }) => { 

  const { t, i18n } = useTranslation()
  const lang = i18n.language


  const purpose = purposes.filter(purpose => {
    return purpose.id === product.acf.extra.purpose
  })[0]

  const tooltip = (content) => {
    return (
      <Tooltip>{content}</Tooltip>
    )
  }

  return (
    <div className="single-product" onClick={onClick}>
      <div className="image">
        <div className="image-wrapper"><img src={product.acf.extra.img} alt="" /></div>        
      </div>
      <div className="name">
        <span className="main">{product.acf.names[`name_${lang}`]}</span>
        <span className="purpose">{purpose.acf.names[`name_${lang}`]}</span>
      </div>
      {product.acf.extra.diameter && (
        <div className="diameter">          
          <Whisper placement="top" trigger="hover" speaker={tooltip(t("Diameter"))}>
            <span>
              φ {product.acf.extra.diameter}
            </span>
          </Whisper>
        </div>
      )}
      {product.acf.intended && (
        <ProductIntendedMaterials
        intendedMaterials={intendedMaterials}
        productMaterials={product.acf.intended}
        productConditionalMaterials={product.acf.intended_conditional}
        />
      )}
    </div>
  )
}

export default ProductsListSingleItem